<div class="space-y-6">
  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm"
  >
    <div class="flex flex-col space-y-1.5 p-6 pb-3">
      <h3 class="font-semibold leading-none tracking-tight text-lg">
        {{ 'SETTINGS.NOTIFICATIONS_PAGE.EMAIL_TITLE' | translate }}
      </h3>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        {{ 'SETTINGS.NOTIFICATIONS_PAGE.EMAIL_SUBTITLE' | translate }}
      </p>
    </div>
    <div class="p-6 pt-0 space-y-6">
      <div class="flex items-center justify-between">
        <div class="space-y-1">
          <p class="font-medium text-sm">
            {{ 'SETTINGS.NOTIFICATIONS_PAGE.ORDERS_TITLE' | translate }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ 'SETTINGS.NOTIFICATIONS_PAGE.ORDERS_SUBTITLE' | translate }}
          </p>
        </div>
        <input type="checkbox" checked class="w-5 h-5 accent-green-600 rounded" />
      </div>
      <div class="border-b border-gray-200 dark:border-gray-800"></div>
      <div class="flex items-center justify-between">
        <div class="space-y-1">
          <p class="font-medium text-sm">
            {{ 'SETTINGS.NOTIFICATIONS_PAGE.LOW_STOCK_TITLE' | translate }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ 'SETTINGS.NOTIFICATIONS_PAGE.LOW_STOCK_SUBTITLE' | translate }}
          </p>
        </div>
        <input type="checkbox" checked class="w-5 h-5 accent-green-600 rounded" />
      </div>
      <div class="border-b border-gray-200 dark:border-gray-800"></div>
      <div class="flex items-center justify-between">
        <div class="space-y-1">
          <p class="font-medium text-sm">
            {{ 'SETTINGS.NOTIFICATIONS_PAGE.WEEKLY_TITLE' | translate }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ 'SETTINGS.NOTIFICATIONS_PAGE.WEEKLY_SUBTITLE' | translate }}
          </p>
        </div>
        <input type="checkbox" checked class="w-5 h-5 accent-green-600 rounded" />
      </div>
      <div class="border-b border-gray-200 dark:border-gray-800"></div>
      <div class="flex items-center justify-between">
        <div class="space-y-1">
          <p class="font-medium text-sm">
            {{ 'SETTINGS.NOTIFICATIONS_PAGE.MARKETING_TITLE' | translate }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ 'SETTINGS.NOTIFICATIONS_PAGE.MARKETING_SUBTITLE' | translate }}
          </p>
        </div>
        <input type="checkbox" class="w-5 h-5 accent-green-600 rounded" />
      </div>
    </div>
  </div>

  <div
    class="rounded-xl border border-gray-200 dark:border-gray-800 bg-white dark:bg-gray-900 text-gray-950 dark:text-gray-100 shadow-sm"
  >
    <div class="flex flex-col space-y-1.5 p-6 pb-3">
      <h3 class="font-semibold leading-none tracking-tight text-lg">
        {{ 'SETTINGS.NOTIFICATIONS_PAGE.PUSH_TITLE' | translate }}
      </h3>
      <p class="text-sm text-gray-500 dark:text-gray-400">
        {{ 'SETTINGS.NOTIFICATIONS_PAGE.PUSH_SUBTITLE' | translate }}
      </p>
    </div>
    <div class="p-6 pt-0 space-y-6">
      <div class="flex items-center justify-between">
        <div class="space-y-1">
          <p class="font-medium text-sm">
            {{ 'SETTINGS.NOTIFICATIONS_PAGE.PUSH_ENABLE_TITLE' | translate }}
          </p>
          <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ 'SETTINGS.NOTIFICATIONS_PAGE.PUSH_ENABLE_SUBTITLE' | translate }}
          </p>
        </div>
        <input type="checkbox" checked class="w-5 h-5 accent-green-600 rounded" />
      </div>
    </div>
  </div>
</div>
